import { Grid, Stack, Typography } from '@mui/material';
import useTranslation, { Translation } from 'hooks/useTranslation/useTranslation';
import React from 'react';
import BatteryAndroid0Outlined from 'v2/assets/vector/lockIcons/BatteryAndroid0Outlined';
import BatteryAndroidFrame1Outlined from 'v2/assets/vector/lockIcons/BatteryAndroidFrame1Outlined';
import BatteryAndroidFrame3Outlined from 'v2/assets/vector/lockIcons/BatteryAndroidFrame3Outlined';
import BatteryAndroidFrameBoltOutlined from 'v2/assets/vector/lockIcons/BatteryAndroidFrameBoltOutlined';
import BatteryAndroidFrameFullOutlined from 'v2/assets/vector/lockIcons/BatteryAndroidFrameFullOutlined';
import BatteryAndroidFrameQuestionOutlined from 'v2/assets/vector/lockIcons/BatteryAndroidFrameQuestionOutlined';
import { ColumnHeaderWithTooltip } from 'v2/components/ColumnHeaderWithTooltip/ColumnHeaderWithTooltip';

interface StatusLegendEntry {
  label: string;
  icon: React.ReactElement;
}

const getFirstStatusLegendColumn = (translation: Translation): StatusLegendEntry[] => [
  { label: translation.empty, icon: <BatteryAndroid0Outlined fontSize="small" /> },
  { label: translation.critical, icon: <BatteryAndroidFrame1Outlined fontSize="small" /> },
  { label: translation.low, icon: <BatteryAndroidFrame3Outlined fontSize="small" /> }
];

const getSecondStatusLegendColumn = (translation: Translation): StatusLegendEntry[] => [
  { label: translation.full, icon: <BatteryAndroidFrameFullOutlined fontSize="small" /> },
  { label: translation.powered, icon: <BatteryAndroidFrameBoltOutlined fontSize="small" /> },
  { label: translation.unknown, icon: <BatteryAndroidFrameQuestionOutlined fontSize="small" /> }
];

const LegendColumn: React.FC<{ entries: StatusLegendEntry[] }> = ({ entries }) => (
  <Stack spacing={1}>
    {entries.map((entry) => (
      <Stack key={entry.label} direction="row" alignItems="center" spacing={1}>
        {entry.icon}
        <Typography variant="caption">{entry.label}</Typography>
      </Stack>
    ))}
  </Stack>
);

export const DeviceStatusColumnHeader: React.FC = () => {
  const { translation } = useTranslation();

  return (
    <ColumnHeaderWithTooltip
      id="header-status"
      label={translation.status}
      tooltip={
        <Stack spacing={1.5}>
          <Typography variant="caption">{translation.device_status_tooltip_description}</Typography>
          <Grid container spacing={1.5}>
            <Grid size={6}>
              <LegendColumn entries={getFirstStatusLegendColumn(translation)} />
            </Grid>
            <Grid size={6}>
              <LegendColumn entries={getSecondStatusLegendColumn(translation)} />
            </Grid>
          </Grid>
        </Stack>
      }
    />
  );
};
